export default "__VITE_ASSET__40a3a073__"